import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api from "../services/api";

export const useAllStudents = () => {
  const queryKey = [QueryKey.AllStudents];

  const queryFn = async () => {
    const URL = `/students`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
  });
};
